type ProductConstantsType = {
  S3_DIR: 'product';
  IMAGE_PERMIT_EXTENSION: 'jpg';
  KENCOS: {
    COMBINATION_MAP: Record<string, string>;
    SERIES_CODE: string[];
    COLORS: { value: string; label: string }[];
    FLAVORS: { value: string; label: string }[];
    LIMITED_COLOR_CODE: string[];
    ORIGINAL_PRICE: number;
  };
  NST_SPECIAL_CARE_SET_CODE: string[];
  SALES_RESTRICTIONS: string[];
};

export const PRODUCT_CONSTANTS: ProductConstantsType = {
  S3_DIR: 'product',
  IMAGE_PERMIT_EXTENSION: 'jpg',
  KENCOS: {
    COMBINATION_MAP: {
      K41KF01: 'SK411', // シャンパン*ビタミン
      K41KF02: 'SK412', // シャンパン*メンソール
      K41KF03: 'SK413', // シャンパン*カテキン
      K42KF01: 'SK421', // ブラック*ビタミン
      K42KF02: 'SK422', // ブラック*メンソール
      K42KF03: 'SK423', // ブラック*カテキン
      K43KF01: 'SK431', // ネイビー*ビタミン
      K43KF02: 'SK432', // ネイビー*メンソール
      K43KF03: 'SK433', // ネイビー*カテキン
      K44KF01: 'SK441', // ホワイト*ビタミン
      K44KF02: 'SK442', // ホワイト*メンソール
      K44KF03: 'SK443', // ホワイト*カテキン
      K45KF01: 'SK451', // ピンク*ビタミン
      K45KF02: 'SK452', // ピンク*メンソール
      K45KF03: 'SK453', // ピンク*カテキン
    },
    SERIES_CODE: ['K41', 'K42', 'K43', 'K44', 'K45'],
    // 色とフレーバーの選択肢。`COMBINATION_MAP` のコメントにしか無かった表示名を、
    // 商品詳細の新デザインがセレクタの選択肢として使うため定数へ起こした（§3.3.2）。
    // 旧実装（撤去済み）の `<option>` ベタ書きと同じ並び・同じ文言。
    COLORS: [
      { value: 'K41', label: 'シャンパンゴールド' },
      { value: 'K42', label: 'ブラック' },
      { value: 'K43', label: 'ネイビー' },
      { value: 'K44', label: 'ホワイト' },
      { value: 'K45', label: 'ピンク' },
    ],
    FLAVORS: [
      { value: 'KF02', label: 'キシリトールメンソール' },
      { value: 'KF03', label: 'カテキングリーン' },
    ],
    LIMITED_COLOR_CODE: ['K41', 'K42'],
    ORIGINAL_PRICE: 44600,
  },
  NST_SPECIAL_CARE_SET_CODE: ['RNS1', 'RNS2', 'RNS3'],
  SALES_RESTRICTIONS: ['KG02', 'KF15'],
} as const;
